export const GET_SCORE_CHART = 'GET_SCORE_CHART';
export const GET_WEEKLY_SUMMARIES = "GET_WEEKLY_SUMMARIES";